module.exports = __webpack_public_path__ + "static/dnk-2e5f0e6a548af499682e65973e0ed7a8.png";